module.exports = __webpack_public_path__ + "assets/img/y5.36dcc3fe.png";